import React, { useRef, useState } from "react";
import styles from "./DeleteMenu.module.css";
import { primaryTextColor, titleXL, fw400 } from "../../../Global.module.css";
import { deleteSlides } from "../../../helpers/api";
import { useOutsideClick } from "../../../helpers/useOutsideClick";
import SnackBar from "../SnackBar/SnackBar";

export default function DeleteMenu({ id, closeDeleteMenu }) {
	const ref = useRef();

	const [sb, setsb] = useState(false);

	useOutsideClick(ref, () => {
		handleCancel();
	});

	const handleDelete = async (id) => {
		try {
			setsb({
				message: "Deleting...",
				severity: "warning",
			});
			await deleteSlides(id);
			closeDeleteMenu(true);
		} catch (error) {
			setsb({
				message: "Delete Request Failed!",
				severity: "error",
			});
		}
	};

	const handleCancel = () => {
		closeDeleteMenu(false);
	};

	const closeSnackBar = () => {
		setsb(false);
	};

	return (
		<div className={styles.deleteMenu} ref={ref}>
			<p className={`${primaryTextColor} ${fw400} ${titleXL}`}>
				Are you sure you want to delete ?
			</p>
			<div className={styles.btnContainer}>
				<button
					className={`${styles.btn} ${styles.cancelBtn}`}
					onClick={handleCancel}
				>
					Cancel
				</button>
				<button
					className={`${styles.btn} ${styles.deleteBtn}`}
					onClick={() => handleDelete(id)}
				>
					Delete
				</button>
			</div>
			{sb && (
				<SnackBar
					open={true}
					message={sb.message}
					severity={sb.severity}
					handleClose={closeSnackBar}
				/>
			)}
		</div>
	);
}
